import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Panel } from '../design/Panel';

/**
 * The join QR. It is the only thing the lobby screen exists for, so it gets the
 * space. Rendered to a data URI at high error correction, in ink on paper, so it
 * scans from across a table.
 */
export function QrPanel({ url }: { url: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void QRCode.toDataURL(url, {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: 720,
      color: { dark: '#1a1714ff', light: '#faf4e6ff' },
    })
      .then((value) => {
        if (!cancelled) setDataUrl(value);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  return (
    <Panel press="lg" rule innerClassName="p-scr-1">
      <div className="h-[50cqh] w-[50cqh] min-h-12 min-w-12 bg-paper-raised">
        {dataUrl && <img src={dataUrl} alt={url} className="h-full w-full" />}
      </div>
    </Panel>
  );
}
